<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      尚景站<br>
站点介绍<br>
尚景站位于龙岗区龙平西路与长兴南路交叉口 处，车站主体沿龙平西路呈东西走向布置，东接盛平站，西接回龙埔站。车站色彩基调以白色调为主，以“世居”为主题，运用暖色系的香槟金色突显世居文化氛围。车站为地下二层结构，地下一层为站厅层，地下二层为站台层，站台形式为岛式站台。车站设置有四个出入口，临近清林小学、龙潭公园，周边为成熟配套生活区。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:03	23:12	16号线	5分32秒	6分38秒<br>
田心	06:21	23:36	16号线	5分32秒	6分38秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:13	23:12	16号线	5分50秒	6分钟-9分钟<br>
田心	06:27	23:36	16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:13	00:12	16号线	5分50秒	6分钟-9分钟<br>
田心	06:27	00:36	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
龙平西路（北）、清林小学、尚景花园、尚景市场、诚亿商行<br><br>
B出入口:<br>
龙平西路（西）、移动机楼、天健郡城、711便利店、天健花园、美宜佳、陈进坤中医内科诊所<br><br>
C出入口:<br>
龙平西路（东）、天集社区公园、天集雅苑、中国民生银行、深圳三为别克、盛平派出所、乐安居<br><br>
D出入口:<br>
龙平西路（南）、深圳红彤丰田汽车公司、爱科思博尔幼儿园、老围新村、锦江都城酒店、悦城花园幼儿园<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 老围新村<br>
M304、M306、M569<br><br>
A出入口:<br>
公交站名： B出入口志达工业园<br>
M303、M304、M306、M317、M569<br><br>
A出入口:<br>
公交站名： C出入口志达工业园<br>
M303、M304、M306、M317、M569<br><br>
A出入口:<br>
公交站名： D出入口老围新村<br>
M304、M306、M569<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiliuhaoxian",
            title: "16号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>